import { Button } from '@/trailmix/Button';
import { Link } from '@inertiajs/react';
import { mdiBookmarkOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { PlaceList } from '@/pages/types';

export function GuestBookmarkCTA({ list }: { list: PlaceList }) {
    return (
        <div className='sticky bottom-4 z-10 mx-0 mb-2 rounded-2xl border border-gray-200 bg-white px-6 py-4 shadow-lg'>
            <div className='flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between'>
                <div className='flex min-w-0 items-center gap-4'>
                    <div className='shrink-0 rounded-full bg-red-100 p-3'>
                        <Icon path={mdiBookmarkOutline} className='size-7 text-red-500' />
                    </div>
                    <div className='min-w-0'>
                        <p className='font-semibold text-gray-900'>Like this list? Save it for later.</p>
                        <p className='text-pretty text-sm text-gray-500'>
                            Save places you want to visit, log your trips, and share your experiences with friends
                            &ndash; it's free.
                        </p>
                    </div>
                </div>
                <div className='flex shrink-0'>
                    <Button as={Link} href={route('register')} variant='primary' className='w-full sm:w-auto'>
                        Get started
                    </Button>
                </div>
            </div>
        </div>
    );
}
